import React from 'react';

export default function Toast({ message, type = 'success', onClose }) {
  if (!message) return null;
  return (
    <div
      className={`toast-notify toast-${type}`}
      style={{
        position: 'fixed',
        top: 100,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        background: type === 'success' ? '#4ade80' : '#f87171',
        color: '#fff',
        padding: '12px 24px',
        borderRadius: 8,
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        minWidth: 250,
        fontWeight: 500,
        textAlign: 'center',
      }}
      onClick={onClose}
    >
      {message}
      <span style={{ marginLeft: 16, cursor: 'pointer', fontWeight: 700 }}>
        ×
      </span>
    </div>
  );
}
